import Contact from "../components/candidate/Contact";
import HomeNavbar from "../components/candidate/HomeNavbar";

export default function Profile() {
  return (
    <>
      <HomeNavbar />
      <Contact />
    </>
  );
}
